import useIsBillingPaused from 'src/hooks/useIsBillingPaused';
import isSubscriptionManagementLocked from './isSubscriptionManagementLocked';

export type SubscriptionLockReason = 'paypal' | 'payment-migration' | null;

/**
 * Whether subscription/billing management is locked for this user, and why.
 * `paypal` (PayPal-on-source customer) takes precedence over the global
 * `payment-migration` pause (the `disable-signup` flag).
 */
export default function useSubscriptionManagementLock(
  subscription: { isPaypalSubscription?: boolean | null } | null | undefined,
): { locked: boolean; reason: SubscriptionLockReason } {
  const billingPaused = useIsBillingPaused();

  let reason: SubscriptionLockReason = null;
  if (isSubscriptionManagementLocked(subscription)) {
    reason = 'paypal';
  } else if (billingPaused) {
    reason = 'payment-migration';
  }

  return { locked: reason !== null, reason };
}
